import { IAppState } from "../state/app.state";
import { createSelector } from "@ngrx/store";
import { ISmartNowState } from "@edp-store/state/smart-now.state";

const smartNowSelector = (state: IAppState) => state.smartNow;

export const getSmartNowStatus = createSelector(smartNowSelector, (state: ISmartNowState) => state.status);
export const getSmartNowAPIError = createSelector(smartNowSelector, (state: ISmartNowState) => state.lastAPIError);
export const getHouseCharacterization = createSelector(smartNowSelector, (state: ISmartNowState) => state.houseCharacterization);
export const getStep = createSelector(smartNowSelector, (state: ISmartNowState) => state.step);
export const getPreviousStepUrl = createSelector(smartNowSelector, (state: ISmartNowState) => state.previousStepUrl);
export const getFlowOrigin = createSelector(smartNowSelector, (state: ISmartNowState) => state.flowOrigin);
export const getConsumptionWithDesaggregation = createSelector(
    smartNowSelector,
    (state: ISmartNowState) => state.consumptionWithDesaggregation
);
export const getPrediction = createSelector(smartNowSelector, (state: ISmartNowState) => state.prediction);
export const getContractOptimization = createSelector(smartNowSelector, (state: ISmartNowState) => state.contractOptimization);
export const getConsumptionPower = createSelector(smartNowSelector, (state: ISmartNowState) => state.consumptionPower);
export const getCurrentPeriodConsumption = createSelector(smartNowSelector, (state: ISmartNowState) => state.currentPeriodConsumption);
export const getConsumptionEvolution = createSelector(smartNowSelector, (state: ISmartNowState) => state.consumptionEvolution);
export const getConsumptionHistory = createSelector(smartNowSelector, (state: ISmartNowState) => state.consumptionHistory);
export const getEfficiencyEnergetic = createSelector(smartNowSelector, (state: ISmartNowState) => state.efficiencyEnergetic);
